
import { supabase } from '@/integrations/supabase/client';
import { SUPABASE_URL } from '@/utils/supabaseConfig';
import { getApiHeaders, handleApiError } from './apiUtils';

// Получение данных аренд из Supabase с использованием клиента с JOIN данными курьеров и велосипедов
export const fetchRentalsWithClient = async (): Promise<{ data: any[] | null; error: any }> => {
  try {
    const { data, error } = await supabase
      .from('rentals')
      .select(`
        *,
        couriers!courier_id (
          id,
          name,
          email,
          phone
        ),
        bikes!bike_id (
          id,
          model,
          serial_number
        ),
        subscriptions (
          id,
          status,
          payment_method_id
        )
      `);
    
    if (error) {
      return { data: null, error };
    }
    
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};

// Получение данных аренд из Supabase с использованием REST API с JOIN данными
export const fetchRentalsWithRest = async (): Promise<{ data: any[] | null; error: any }> => {
  try {
    const response = await fetch(`${SUPABASE_URL}/rest/v1/rentals?select=*,couriers!courier_id(id,name,email,phone),bikes!bike_id(id,model,serial_number),subscriptions(id,status,payment_method_id)`, {
      method: 'GET',
      headers: getApiHeaders()
    });
    
    if (!response.ok) {
      return await handleApiError(response);
    }
    
    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    return { data: null, error };
  }
};
